export default __webpack_public_path__ + "static/media/featured.928305bb.png";